import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconUpload(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M19 6a1 1 0 1 0 0-2H5a1 1 0 1 0 0 2h14Zm-6.293 2.293a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L11 11.414V19a1 1 0 1 0 2 0v-7.586l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
